// Mixins
import { dateMixins } from '@/app/mixins/utils/date-mixins';
    
export default {
    name: 'Timeline',
    mixins: [ dateMixins ],
    props: {
        dataList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        timelineColor:{
            type: String,
            default: '#f9faff'
        },
        timeContentColor:{
            type: String,
            default: '#f2f2f2'
        },
        noDataText:{
            type: String,
            default: 'No available data.'
        }
    },
    data() {
        return {
            infiniteId: +new Date()
        }
    },
    mounted() {
        const timeline = this.$refs.timeline;
        timeline.style.setProperty('--timelineColor', this.timelineColor)
        timeline.style.setProperty('--timeContentColor', this.timeContentColor)
    },
    methods: {
        infiniteHandler() {
            this.$emit('infiniteHandler');
        }
    }
}